import { useState, type ReactNode } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/components';
import type { AccountMarginRest, AccountRest } from '@/entities/account';
import { useAccountRows } from '../model/useAccountRows';
import { AccountRowContent } from './AccountRowContent';

type Props = {
  accounts: Array<AccountRest | AccountMarginRest>;
  currency: string;
  precision: number;
  isBalancesHidden: boolean;
  onSelect: (accountNumber: string) => void;
  children: ReactNode;
};

const AccountsTransferPopover = ({
  accounts,
  currency,
  precision,
  isBalancesHidden,
  onSelect,
  children,
}: Props) => {
  const [open, setOpen] = useState(false);
  const rows = useAccountRows(accounts);

  const handleSelect = (accountNumber: string) => {
    setOpen(false);
    onSelect(accountNumber);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>

      <PopoverContent
        align="start"
        sideOffset={8}
        collisionPadding={16}
        sticky="always"
        className="flex flex-col gap-[0.8rem] w-[23.6rem] max-h-(--radix-popover-content-available-height) overflow-y-auto p-[0.4rem] rounded-[1.2rem] border-stroke bg-background/94 backdrop-blur-[0.8rem] shadow-(--shadow-dropdown)!">
        {rows.map(row => (
          <button
            key={row.accNum}
            type="button"
            onClick={() => handleSelect(row.accNum)}
            className="flex w-full h-[3.6rem] shrink-0 items-center px-[1.2rem] py-[0.8rem] rounded-[0.8rem] cursor-pointer hover:bg-secondary-bg">
            <AccountRowContent
              row={row}
              currency={currency}
              precision={precision}
              isBalancesHidden={isBalancesHidden}
            />
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export { AccountsTransferPopover };
